



















































































































import { baseUrl } from "@/baseUrl";
import Vue from "vue";

export default Vue.extend({
  name: "Login",

  data: () => ({
    valid: false,
    showError: false,
    email: "",
    emailRules: [
      (v: any) => !!v || "E-mail is required",
      (v: any) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    password: "",
    baseUrl: baseUrl,
  }),

  components: {},

  methods: {
    async onLogin() {
      if (process.env.NODE_ENV !== "production") {
        this.$store.dispatch("setUser", {
          email: "daan@webdimensie.nl",
          id: "4",
          role: "leverancier",
        });

        this.$router.push("/");
      } else {
        this.showError = false;
        if (this.valid) {
          this.postData().then((data) => {
            if (data.id) {
              this.$store.dispatch("setUser", data);
              this.$router.push("/");
            }
          });
        } else {
          this.showError = true;
        }
      }
    },
    async postData() {
      try {
        const response = await fetch(`${this.$api}/login`, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          redirect: "follow",
          referrerPolicy: "no-referrer",
          body: JSON.stringify({
            username: this.email,
            password: this.password,
          }),
        });
        return response.json();
      } catch (e) {
        console.error(e);
      }
    },
  },
});
